import { jsxs as i, jsx as a } from "react/jsx-runtime";
import { c as l } from "./tw-cn-mXgPecoF.mjs";
import { c as s } from "./index-BpNK5r1N.mjs";
const d = s("", {
  variants: {
    size: {
      xlarge: "size-40",
      large: "size-18",
      medium: "size-16",
      small: "size-12"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), g = s("", {
  variants: {
    size: {
      xlarge: "typography-headline-40-bold",
      large: "typography-subtitle-16-bold",
      medium: "typography-body-14-bold",
      small: "typography-body-12-bold"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), c = s("", {
  variants: {
    size: {
      xlarge: "typography-headline-32-regular",
      large: "typography-body-14-regular",
      medium: "typography-body-14-regular",
      small: "typography-body-12-regular"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), h = ({ score: e, reviewCount: r, size: t }) => {
  const o = d({ size: t }), n = g({ size: t }), L = c({ size: t });
  return /* @__PURE__ */ i("div", { className: "flex items-center space-x-2", children: [
    /* @__PURE__ */ a(m, { className: o }),
    /* @__PURE__ */ a("span", { className: l(n, "font-bold"), children: e }),
    !!r && /* @__PURE__ */ i("span", { className: l(L), children: [
      "(",
      r,
      ")"
    ] })
  ] });
}, m = ({ className: e }) => /* @__PURE__ */ a(
  "svg",
  {
    className: e,
    fill: "none",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ a(
      "path",
      {
        d: "M12.6378 2.471C11.9186 2.12165 11.0582 2.41284 10.6932 3.12262L8.43934 7.69022L8.43867 7.69154C8.38397 7.79982 8.2801 7.86945 8.18409 7.88316L8.18244 7.8834L3.15594 8.61289C2.86708 8.65248 2.54544 8.78763 2.3065 9.0592C2.03712 9.3421 1.91016 9.71843 1.91016 10.0656C1.91016 10.4657 2.0772 10.8334 2.33978 11.096L5.98649 14.6526L5.99032 14.6563C6.06045 14.7237 6.10204 14.8298 6.08059 14.961L6.08036 14.9623L5.22086 19.9687L5.21888 19.9816C5.17571 20.2622 5.22382 20.5128 5.28332 20.7062L5.29395 20.7407L5.30785 20.7741C5.40366 21.004 5.5636 21.231 5.79903 21.4022C6.03154 21.5713 6.28728 21.6538 6.54263 21.6734L6.57135 21.6756H6.60016C6.80417 21.6756 7.05917 21.6446 7.31557 21.5164L7.32265 21.5129L11.8296 19.1392L11.832 19.138C11.932 19.0848 12.0483 19.0848 12.1483 19.138L12.1507 19.1392L16.6577 21.5129L16.6647 21.5164C16.9235 21.6458 17.2508 21.7188 17.5914 21.6522C18.3594 21.5078 18.8956 20.7777 18.771 19.9886L17.9094 14.9689C17.8927 14.8719 17.923 14.7512 18.0145 14.6522L21.6438 11.1126L21.6505 11.106C21.8746 10.8818 22.0093 10.6043 22.0656 10.3227L22.0689 10.3063L22.0714 10.2897C22.1961 9.47904 21.6358 8.77062 20.871 8.63873L20.8423 8.63247L15.8105 7.88376L15.8033 7.88276C15.695 7.86771 15.6074 7.8065 15.555 7.69841L13.3027 3.13376L13.301 3.13022C13.1584 2.84507 12.9307 2.61733 12.6456 2.47476L12.6378 2.471Z",
        fill: "#FDBA39"
      }
    )
  }
);
export {
  h as S
};
